/**
 * Email Verification Dialog
 *
 * Modal displayed after password-based registration to inform
 * the user that a verification email has been sent.
 */

import { useTranslation } from "../../hooks/useTranslation";

export interface EmailVerificationDialogProps {
  /** Email address where verification was sent */
  email: string;
  /** Callback when user acknowledges the dialog */
  onClose: () => void;
}

/**
 * Dialog component shown after successful password registration
 *
 * Informs the user that a verification email has been sent and
 * provides a button to acknowledge and return to login.
 */
export function EmailVerificationDialog({
  email,
  onClose,
}: EmailVerificationDialogProps) {
  const t = useTranslation();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 px-4">
      <div className="bg-white rounded-lg p-6 w-full max-w-md shadow-xl">
        <h2 className="text-lg font-semibold text-gray-900">
          {t("verificationSentTitle")}
        </h2>
        <p className="mt-2 text-gray-700">{t("verificationSentBody", email)}</p>
        <button
          className="mt-6 w-full bg-red-600 hover:bg-red-700 text-white rounded-md py-3"
          onClick={onClose}
        >
          {t("okGotIt")}
        </button>
      </div>
    </div>
  );
}
